/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerWithdrawRequestsBySelfOptions,
  GetLedgerWithdrawRequestsBySelfStatus200,
  GetLedgerWithdrawRequestsBySelfStatus400,
  GetLedgerWithdrawRequestsBySelfStatus404,
  GetLedgerWithdrawRequestsBySelfStatus500,
} from '../types/GetLedgerWithdrawRequestsBySelf'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerWithdrawRequestsBySelf } from '../clients/getLedgerWithdrawRequestsBySelf'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerWithdrawRequestsBySelfQueryKey = ({
  query,
}: Omit<GetLedgerWithdrawRequestsBySelfOptions, 'headers'> = {}) =>
  [{ url: '/v1/ledger/withdraw/requests/self' }, ...(query ? [query] : [])] as const

type GetLedgerWithdrawRequestsBySelfQueryKey = ReturnType<
  typeof getLedgerWithdrawRequestsBySelfQueryKey
>

export function getLedgerWithdrawRequestsBySelfQueryOptions(
  { query }: GetLedgerWithdrawRequestsBySelfOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerWithdrawRequestsBySelfQueryKey({ query })
  return queryOptions<
    GetLedgerWithdrawRequestsBySelfStatus200,
    ResponseErrorConfig<
      | GetLedgerWithdrawRequestsBySelfStatus400
      | GetLedgerWithdrawRequestsBySelfStatus404
      | GetLedgerWithdrawRequestsBySelfStatus500
    >,
    GetLedgerWithdrawRequestsBySelfStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerWithdrawRequestsBySelf({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get all pending withdrawal requests for the logged in user
 * {@link /v1/ledger/withdraw/requests/self}
 */
export function useGetLedgerWithdrawRequestsBySelf<
  TData = GetLedgerWithdrawRequestsBySelfStatus200,
  TQueryData = GetLedgerWithdrawRequestsBySelfStatus200,
  TQueryKey extends QueryKey = GetLedgerWithdrawRequestsBySelfQueryKey,
>(
  {
    query,
  }: {
    query?:
      | GetLedgerWithdrawRequestsBySelfOptions['query']
      | (() => GetLedgerWithdrawRequestsBySelfOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerWithdrawRequestsBySelfStatus200,
        ResponseErrorConfig<
          | GetLedgerWithdrawRequestsBySelfStatus400
          | GetLedgerWithdrawRequestsBySelfStatus404
          | GetLedgerWithdrawRequestsBySelfStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey =
    resolvedOptions?.queryKey ?? getLedgerWithdrawRequestsBySelfQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getLedgerWithdrawRequestsBySelfQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetLedgerWithdrawRequestsBySelfStatus400
      | GetLedgerWithdrawRequestsBySelfStatus404
      | GetLedgerWithdrawRequestsBySelfStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
